export default "__VITE_ASSET__BrMGoUmg__"